/**
 * Color intention that you want to use in your theme
 * @param {JsonObject} theme Theme customization object
 */
export function themePalette(theme = {}) {
    // Use a new object to avoid mutating the original theme object
    const colors = theme.colors || {
        primaryLight: '#f0f0f0',
        primaryMain: '#2196f3',
        primaryDark: '#1976d2',
        primary200: '#90caf9',
        primary800: '#1565c0',
        secondaryLight: '#c8e6c9',
        secondaryMain: '#4caf50',
        secondaryDark: '#388e3c',
        secondary200: '#a5d6a7',
        secondary800: '#2e7d32',
        errorLight: '#e57373',
        errorMain: '#f44336',
        errorDark: '#d32f2f',
        orangeLight: '#ffcc80',
        orangeMain: '#ff9800',
        orangeDark: '#ef6c00',
        warningLight: '#ffb74d',
        warningMain: '#ff9800',
        warningDark: '#f57c00',
        successLight: '#81c784',
        success200: '#66bb6a',
        successMain: '#4caf50',
        successDark: '#388e3c',
        grey50: '#fafafa',
        grey100: '#f5f5f5',
        grey500: '#9e9e9e',
        grey700: '#616161',
        grey900: '#212121',
        textDark: '#212121',
        darkTextPrimary: '#616161',
        darkTextSecondary: '#9e9e9e',
        background: '#e3f2fd',
        paper: '#ffffff'
    };
    console.log('Theme Palette Colors:', colors); // Debugging line
    return {
        mode: theme.customization?.navType || 'light', // Provide a default value
        common: {
            black: '#000000'
        },
        primary: {
            light: colors.primaryLight,
            main: colors.primaryMain,
            dark: colors.primaryDark,
            200: colors.primary200,
            800: colors.primary800
        },
        secondary: {
            light: colors.secondaryLight,
            main: colors.secondaryMain,
            dark: colors.secondaryDark,
            200: colors.secondary200,
            800: colors.secondary800
        },
        error: {
            light: colors.errorLight,
            main: colors.errorMain,
            dark: colors.errorDark
        },
        orange: {
            light: colors.orangeLight,
            main: colors.orangeMain,
            dark: colors.orangeDark
        },
        warning: {
            light: colors.warningLight,
            main: colors.warningMain,
            dark: colors.warningDark
        },
        success: {
            light: colors.successLight,
            200: colors.success200,
            main: colors.successMain,
            dark: colors.successDark
        },
        grey: {
            50: colors.grey50,
            100: colors.grey100,
            500: colors.grey500,
            600: theme.heading || '#757575', // Provide a default for theme.heading if undefined
            700: colors.grey700,
            900: colors.grey900
        },
        text: {
            primary: colors.darkTextPrimary,
            secondary: colors.darkTextSecondary,
            dark: colors.textDark,
            hint: colors.grey100
        },
        background: {
            paper: colors.paper,
            default: colors.background
        }
    };
}
